<div class="operation-confirmation-page">

  <div class="page-intro">
    <b3-breadcrumbs aria-label="Breadcrumb">
      <b3-breadcrumbs-item variant="icon" href="/"></b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Operações de crédito</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Operações</b3-breadcrumbs-item>
      <b3-breadcrumbs-item variant="item">Confirmar operação</b3-breadcrumbs-item>
    </b3-breadcrumbs>
    <h1 class="page-title">Confirmação de Depósito de Créditos</h1>
  </div>

  <section class="consult-content" aria-label="Confirmação de operações de crédito de carbono">
    <div class="consult-toolbar">
      <div class="consult-toolbar__action">
        <b3-button
          type="button"
          variant="outlined"
          tone="default"
          size="md"
          class="consult-toolbar__filter-btn"
          [attr.aria-label]="filterButtonAriaLabel"
          (b3-click)="openFilter()">
          <b3-icon name="filter_alt"></b3-icon>
          <span class="consult-toolbar__filter-count">({{ activeFiltersCount }})</span>
          Filtrar
        </b3-button>
      </div>
    </div>

    <div class="consult-filter-feedback" *ngIf="showFilterUpdateNotice">
      <b3-toast
        [open]="true"
        variant="info"
        label="Consulta atualizada para os filtros aplicados"
        aria-live="polite">
        <b3-button
          slot="action"
          variant="ghost"
          tone="default"
          (b3-click)="onFilterNoticeUndo()">
          Desfazer
        </b3-button>
        <b3-button
          slot="close"
          variant="ghost"
          tone="default"
          aria-label="Fechar aviso de filtros"
          (b3-click)="onFilterNoticeDismiss()">
          <b3-icon name="clear" size="sm" tone="default"></b3-icon>
        </b3-button>
      </b3-toast>
    </div>

    <p class="consult-table-summary" aria-live="polite">
      {{ confirmationTable?.operationsFoundLabel }}
    </p>

    <app-operation-confirmation-table
      #operationConfirmationTable
      (emitClick)="handleTableAction($event)">
    </app-operation-confirmation-table>
  </section>

  <footer class="page-footer">
    <p class="page-footer__text">B3SA© 2026 Plataforma de Carbono. Todos os direitos reservados.</p>
  </footer>
</div>

<app-operation-confirmation-filter
  [isOpen]="showFilter"
  (closed)="showFilter = false">
</app-operation-confirmation-filter>

<app-operation-confirmation-approve-modal
  [open]="isApproveModalOpen"
  (closed)="onApproveModalClosed($event)">
</app-operation-confirmation-approve-modal>

<app-operation-confirmation-reject-modal
  [open]="isRejectModalOpen"
  (closed)="onRejectModalClosed($event)">
</app-operation-confirmation-reject-modal>

<app-operation-confirmation-details-drawer
  [isOpen]="isDetailsDrawerOpen"
  [operation]="selectedOperationForDetails"
  (closed)="onDetailsDrawerClosed()">
</app-operation-confirmation-details-drawer>

<b3-toast-region class="operation-confirmation-toast-region">
  <b3-toast
    *ngIf="activeToast as toast"
    [open]="toast.open"
    [variant]="toast.variant"
    [label]="toast.label"
    [description]="toast.description"
    auto-dismiss
    (b3-close)="onToastDismiss()">
    <b3-button
      aria-label="Fechar notificação"
      (b3-click)="onToastDismiss()">
      <b3-icon name="close"></b3-icon>
    </b3-button>
  </b3-toast>
</b3-toast-region>
